import { render, staticRenderFns } from "./logEdit.vue?vue&type=template&id=21cbf5f0&scoped=true&"
import script from "./logEdit.vue?vue&type=script&lang=js&"
export * from "./logEdit.vue?vue&type=script&lang=js&"
import style0 from "./logEdit.vue?vue&type=style&index=0&id=21cbf5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbf5f0",
  null
  
)

export default component.exports